<mat-card class="auth mat-elevation-z" [class.pe-none]="isLoading">
	<mat-card-header class="flex-column align-items-center">
		<img [src]="'assets/images/auth/otp.svg' | s3Image" alt="otp" />

		<h1 class="v2">{{ translations['n562'] }}</h1>

		<p class="text-body-14px-regular fg-grey text-center m-0">
			{{ translations['n539'] }}
			<span class="text-body-14px-medium">{{ phone }}</span>
		</p>
	</mat-card-header>

	<form [formGroup]="form">
		<mat-card-content class="p-0">
			<!-- OTP input -->
			<app-input
				class="otp"
				#otpInput
				[id]="'otpInput'"
				wrapperClass="no-subscript"
				formControlName="otp"
				maxLength="6"
				type="text"
				pattern="\d*"
				placeholder="000000"
			></app-input>
		</mat-card-content>

		<mat-card-actions class="p-0 m-0">
			<!-- Verify button -->
			<app-button
				customClass="w-100 h-100"
				[label]="translations[btnVerifyLabel]"
				[isLoading]="isLoading"
				[hasSpinner]="true"
				[isDisabled]="form.invalid"
				(clicked)="onVerifyOtp()"
			></app-button>

			<!-- Call for help button -->
			<app-button
				*ngIf="canCallForHelp"
				class="whatsapp"
				customClass="w-100 h-100"
				[label]="translations['n572']"
				svgIcon="whatsapp"
				[disableRipple]="true"
				[btnType]="buttonType.STROKED"
				(click)="onOpenWhatsApp()"
			></app-button>

			<div class="resend-code text-center">
				<ng-container *ngIf="remainingTime > 0; else resendCode">
					<span class="text-body-14px-regular fg-grey">
						{{ translations['n541'] }}
						{{ remainingTime }}
					</span>
				</ng-container>

				<ng-template #resendCode>
					<!-- Resend code button -->
					<app-button
						customClass="lh-1 h-auto"
						type="reset"
						[label]="translations[btnResendLabel]"
						[disableRipple]="true"
						[btnType]="buttonType.BASIC"
						[isLoading]="isResending"
						(clicked)="onResendCode()"
					></app-button>
				</ng-template>
			</div>

			<div class="text-center" *ngIf="canChangeNumber">
				<span class="text-body-14px-regular fg-grey">{{ translations['n542'] }}</span>

				<!-- Change number button -->
				<app-button
					class="change-number"
					customClass="p-0 lh-1 h-auto"
					[label]="translations['n543']"
					[isLoading]="isLoading"
					[disableRipple]="true"
					[btnType]="buttonType.BASIC"
					(clicked)="onChangeNumber()"
				></app-button>
			</div>
		</mat-card-actions>
	</form>
</mat-card>
